// Módulos
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, catchError, delay, map, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { of } from 'rxjs';


// Servicios
import { ModalImagenService } from '../modal-imagen.service';
import { NotificacionesService } from '../notificaciones.service';

// Modelos e Interfaces
import { IApiResp } from '../../interfaces/api-resp';
import { RegistroUsuario } from '../../interfaces/registro-usuario';
import { environment } from 'src/environments/environment';
import { IUsuario } from 'src/app/interfaces/usuario';


@Injectable({
  providedIn: 'root'
})

export class UsuarioService {

  apiURL: string = environment.apiURL;
  userdata: IUsuario = {}

  // Evento para notificar cambios en la autenticación (login/logout)
  private authChange$ = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private notificacionesSrv: NotificacionesService,
    private modalImagenSrv: ModalImagenService
  ) { }

  ////////// AUTH  /////////



  logIn(formData: any) {
    const path = `${this.apiURL}/login`;
    return this.http.post<IApiResp>(path, formData)
      .pipe(
        catchError(error => {
          console.log('Error al intentar autenticar:', error);
          this.notificacionesSrv.aviso('error', 'Error al intentar autenticar, el servidor no está respondiendo. Por favor, intenta de nuevo más tarde.');
          return throwError(() => new Error(error));
        }),
        tap(resp => {
          if (resp.data.token) {
            this.userdata = resp.data.userdata;
            localStorage.setItem('token', resp.data.token);
            this.authChange$.next(true); // Emitir éxito de login
          }
        })
      );
  }


  logOut() {
    localStorage.removeItem('token');
    this.authChange$.next(false); // Emitir logout
    console.log('__LOGOUT__');
    this.router.navigateByUrl('/login');
  }


  validarToken(): Observable<boolean> {
    const token = localStorage.getItem('token') || '';
    const cabeceras = new HttpHeaders().append(
      'Authorization', 'Bearer ' + token
    );
    return this.http.get<any>(`${this.apiURL}/refreshToken`, {
      headers: cabeceras
    })
      .pipe(
        catchError(error => {
          console.log('Error al intentar acceder al srvidor:', error);
          this.notificacionesSrv.aviso('error', `El servidor ${this.apiURL} no está respondiendo. Por favor, intenta de nuevo más tarde.`);
          this.logOut();
          return throwError(() => new Error(error));
        }),
        tap(resp => {
          if (resp.data.token) {
            // guardamos el nuevo token y cargamos los valores del usuario
            localStorage.setItem('token', resp.data.token);
            this.userdata = resp.data.userdata;
            this.authChange$.next(true); // Emitir token válido
          }
        }),
        map(resp => {
          // devolver true solo si la API no devuelve error
          return (!resp.error);
        })
      );
  }

  crearUsuario(formData: RegistroUsuario) {
    const path = `${this.apiURL}/register`;
    return this.http.post<IApiResp>(path, formData);
  }



  getUserDetall(id_usr: number) {
    // Devulve un registro de usr
    const path = `${this.apiURL}/usrList/${id_usr}`;
    const resp = this.http.get<IApiResp>(path)
    console.log('__SERVICO getUserDetall() path: ', path);
    return resp;
  }


  //////  GET usr data  ///////
  getUsr(): Observable<any> {
    return of(this.userdata);
  }

  // Observable para suscribirse a cambios de autenticacion
  get onAuthChange() {
    return this.authChange$.asObservable();
  }

  getProfile(): Observable<any> {
    // Devulve la info del Token
    const path = `${this.apiURL}/profile`;
    return this.http.get<IApiResp>(path);
  }




  getUserFoto() {
    // Devuleve la foto del usuario
    var foto = this.userdata.foto || null;
    if (foto) {
      foto = `${environment.fotoDir}/users/${foto}`;
    } else {
      foto = `${environment.fotoDir}/users/_noFoto.png`;
    }
    return (foto);
  }


  getLista() {
    // Devulve la lista de usuarios
    const path = `${this.apiURL}/usrList`;
    const lista = this.http.get<IApiResp>(path)
      .pipe(
      // delay(10)
    );
    return lista;
  }

  getUsrCliList(id_cliente: number) {
    // Devulve la lista de usuarios de un cliente
    const path = `${this.apiURL}/usrCliList/${id_cliente}`;
    const lista = this.http.get<IApiResp>(path)
    return lista;
  }


  getUsrListRol(params: any) {
    // Devulve usuarios con el rol x del almacén y
    const path = `${this.apiURL}/usrListRol`;
    return this.http.post<IApiResp>(path, params)
      .pipe(
        catchError(error => {
          console.log('ERROR:', error);
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }


  // CRUD 

  //  Modificar usuario por su id  
  userUpdate(datos: IUsuario) {
    console.log('__ServicioUsr datos:', datos)
    const path = `${this.apiURL}/userUpdate/${datos.id}`;

    return this.http.post<IApiResp>(path, datos)
      .pipe(
        catchError(error => {
          console.log('ERROR:', error);
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }



  // AÑADIR usuario  
  userNew(datos: IUsuario) {
    const path = `${this.apiURL}/userNew`;

    console.log('__ServicioUsr userNew path:', path)
    console.log('__ServicioUsr userNew datos:', datos)

    return this.http.post<IApiResp>(path, datos)
      .pipe(
        catchError(error => {
          console.log('__ERROR__:', error);
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }


  deleteUsr(id: number) {
    // Borra un usuario
    const path = `${this.apiURL}/userDelete/${id}`;
    return this.http.get<IApiResp>(path)
      .pipe(
        catchError(error => {
          console.log('ERROR:', error);
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }


  getUserByRestore(restore: string) {
    // Devulve un registro de usr
    const path = `${this.apiURL}/getUserByRestore/${restore}`;
    const resp = this.http.get<IApiResp>(path)
    return resp;
  }

  pswChange(data: any) {
    const path = `${this.apiURL}/pswChange`;
    return this.http.post<IApiResp>(path, data);
  }

  // Cambio de contraseña pasando id_usuario, psw y psw2
  userUpdatePsw(data: any) {
    const path = `${this.apiURL}/userUpdatePsw`;
    return this.http.post<IApiResp>(path, data)
  }



  // Solicitud de cambio de contraseña
  pswLost(data: unknown) {
    const path = `${this.apiURL}/pswLost`;
    return this.http.post<IApiResp>(path, data)
      .pipe(
        catchError(error => {
          console.log('ERROR:', error);
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }



  ///// AUX ////

  errorAuth() {
    this.logOut();
    this.modalImagenSrv.cerrarModal();
    console.log('error', environment.apiErrorAuth);
    // this.notificacionesSrv.aviso('error', environment.apiErrorAuth);
  }

}
